/* eslint-env browser */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const backendApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '/v1/' }),
  tagTypes: [],
  endpoints: (builder) => ({
    getUserContext: builder.query<AU.IUserContext, void>({
      query: () => 'usercontext',
    }),
  }),
});

export const { useGetUserContextQuery } = backendApi;
